import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { hardenGlobals } from "./lib/harden";
import { migrateLegacyHashUrl } from "./lib/router-safe";
import { initNative } from "./lib/native";
import "./index.css";

// Restore pristine browser APIs before React mounts, so extensions that patch
// core DOM methods (e.g. ClickUp) can't crash the router at render time.
hardenGlobals();
// Old shared links used #/path — rewrite them to clean URLs before React mounts.
migrateLegacyHashUrl();
// Increment 45a: initialize native integrations (no-op on web).
void initNative();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
